import { FC } from 'react';

interface IUndergroundReleaseYearProps {
  releaseYear: number;
}

export const UndergroundReleaseYear: FC<IUndergroundReleaseYearProps> = ({ releaseYear }) => {
  return <> &#183; {releaseYear}</>;
};
